<template>
  <Form
    :action="action"

    :init-data="initData"
    :disabled="readonly"
    :readonly="readonly"

    :label-width="120"
    @cancel="$emit('cancel')"
  >
    <FormField
      v-for="field in fields"
      :key="field.name"

      :name="field.name"
      :prop="field.prop"
      :type="field.type"
      :validate="field.validate"

      :type-options="field.typeOptions"

      :label="field.label"
      :placeholder="field.placeholder"
    />
  </Form>
</template>

<script>
import Form from './Form.vue';
import FormField from './FormField.vue';

export default {
  name: 'GdlFormDSL',
  components: { Form, FormField },
  props: {
    fields: { type: Array, required: true },
    action: { type: Function, default: () => {} },
    initData: { type: Object, default: undefined },

    readonly: { type: Boolean, default: false },
  },
};
</script>
